import React from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { BreadcrumbsV2 } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphsRenderer } from '../../../components';
import type { NodeBasicPage as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface BasicPageProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeBasicPage: React.FC<BasicPageProps> = ({ entity, className }) => {
  const classes = classNames('Node', 'NodeBasicPage', className);
  const basicPage = entity.toJS();
  const title = basicPage.title[0].value;
  const body = basicPage.body[0]?.processed;
  const paragraphs = basicPage.field_paragraphs;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeBasicPage__hero">
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1">
              <BreadcrumbsV2 showHomeIcon={false} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1">
              <h1 className="NodeBasicPage__title" itemProp="title">
                {title}
              </h1>

              {body && (
                <WysiwygField
                  className="NodeBasicPage__body body--large"
                  property="schema:text"
                  html={body}
                />
              )}
            </div>
          </div>
        </Container>
      </div>

      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1">
            <ParagraphsRenderer className="NodeBasicPage__paragraphs" paragraphs={paragraphs} noBootstrap />
          </div>
        </div>
      </Container>
    </article>
  );
};

export default NodeBasicPage;
